import { BarChart3, Boxes, Gavel, LayoutDashboard, ListChecks, MessagesSquare } from 'lucide-react';

import type { NavItem } from './MainSidebar.types';

// Platform-level entry: lists every module, unaffected by the module selector.
export const MODULES_NAV_ITEM: NavItem = { to: '/modules', labelKey: 'nav.modules', shortcut: 'G M', icon: Boxes };

// Module-scoped views: filtered by the selected module.
export const NAV_ITEMS: NavItem[] = [
	{ to: '/', labelKey: 'nav.dashboard', shortcut: 'G D', icon: LayoutDashboard },
	{ to: '/conversations', labelKey: 'nav.conversations', shortcut: 'G C', icon: MessagesSquare },
	{ to: '/judges', labelKey: 'nav.judges', shortcut: 'G J', icon: Gavel },
	{ to: '/evaluations', labelKey: 'nav.evaluations', shortcut: 'G E', icon: ListChecks },
	{ to: '/reports', labelKey: 'nav.reports', shortcut: 'G R', icon: BarChart3 },
];
